module.exports = __webpack_public_path__ + "media/images/icons/v2/check-circle-b199b8888fea24888236e95927ed3373.svg";